import { request } from '@/utils/request'
import type {
  BasisRes,
  KlinePeriod,
  MarketStatusRes,
  QuoteCategory,
  QuoteDetailRes,
  QuoteKlineRes,
  QuotePriceType,
  QuoteSourcesRes,
  QuotesCategoryRes,
  QuotesTickerRes,
} from '@/api/types/quotes'

/** 真实盘态（官方交易日历 + 上金所日盘/夜盘时段） */
export function getMarketStatus(): Promise<MarketStatusRes> {
  return request<MarketStatusRes>({
    url: '/api/v1/quotes/market-status',
    method: 'GET',
    withAuth: false,
  })
}

/** 基差（国内 vs 国际 + 金银比） */
export function getQuotesBasis(): Promise<BasisRes> {
  return request<BasisRes>({
    url: '/api/v1/quotes/basis',
    method: 'GET',
    withAuth: false,
  })
}

export function getQuotesTicker(): Promise<QuotesTickerRes> {
  return request<QuotesTickerRes>({
    url: '/api/v1/quotes/ticker',
    method: 'GET',
    withAuth: false,
  })
}

export function getQuotesCategory(category: QuoteCategory): Promise<QuotesCategoryRes> {
  return request<QuotesCategoryRes>({
    url: `/api/v1/quotes/${category}`,
    method: 'GET',
    withAuth: false,
  })
}

export function getQuoteDetail(symbol: string): Promise<QuoteDetailRes> {
  return request<QuoteDetailRes>({
    url: `/api/v1/quotes/${encodeURIComponent(symbol)}`,
    method: 'GET',
    withAuth: false,
  })
}

export function getQuoteKline(
  symbol: string,
  period: KlinePeriod,
  limit = 60,
  options?: { source?: string; priceType?: QuotePriceType },
): Promise<QuoteKlineRes> {
  const query = [
    `period=${period}`,
    `limit=${limit}`,
    options?.source ? `source=${encodeURIComponent(options.source)}` : '',
    options?.priceType ? `priceType=${options.priceType}` : '',
  ].filter(Boolean).join('&')
  return request<QuoteKlineRes>({
    url: `/api/v1/quotes/${encodeURIComponent(symbol)}/kline?${query}`,
    method: 'GET',
    withAuth: false,
  })
}

export function getQuoteSources(symbol: string): Promise<QuoteSourcesRes> {
  return request<QuoteSourcesRes>({
    url: `/api/v1/quotes/${encodeURIComponent(symbol)}/sources`,
    method: 'GET',
    withAuth: false,
  })
}

export function syncQuotesDev(): Promise<{ symbolCount: number }> {
  return request<{ symbolCount: number }>({
    url: '/api/v1/quotes/sync',
    method: 'POST',
    withAuth: false,
  })
}
